var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcModalButtonLeftCorner = function SvgIcModalButtonLeftCorner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 33 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F8957F",
    d: "M19.099 18.13H.106v-.89h18.362l11.254-9.905V0h1.3v7.642L19.098 18.13Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD5B9",
    d: "M19.768 19H.106v-.89h19.005l11.65-10.533V.242h1.345v7.642L19.768 19Z",
    opacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#E66549",
    d: "M18.416 17.2H.398v-.847h17.42l10.675-9.397V0h1.235v7.246l-11.312 9.953Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#E66549",
    d: "m21.816 11.273-4.282 4.56h-4.522l4.522-4.56h4.282Z"
  })));
};
export default SvgIcModalButtonLeftCorner;